export { default } from './Order'



// WEBPACK FOOTER //
// ./src/App/pages/Order/index.js